import React from "react";
import { Button } from "@/components/ui/button";

/**
 * Phoenix brand-styled Button.
 * Wraps shadcn's Button and applies the Phoenix tokens for the four
 * variants used across modules.
 */
export function PhxButton({ variant = "primary", className = "", ...rest }) {
  const variants = {
    primary:
      "bg-[var(--phx-brand-primary)] text-[var(--phx-brand-primary-contrast)] hover:bg-[var(--phx-brand-hover)] rounded-[var(--phx-radius-md)]",
    secondary:
      "bg-[var(--phx-brand-ink)] text-white hover:opacity-90 rounded-[var(--phx-radius-md)]",
    ghost:
      "bg-transparent text-[var(--phx-brand-ink)] hover:bg-[var(--phx-slate-100)] rounded-[var(--phx-radius-md)]",
    danger:
      "bg-[var(--phx-status-danger)] text-white hover:opacity-90 rounded-[var(--phx-radius-md)]",
    outline:
      "border border-[var(--phx-brand-input)] bg-white text-[var(--phx-brand-ink)] hover:bg-[var(--phx-slate-50)] rounded-[var(--phx-radius-md)]",
  };
  return <Button className={`min-h-9 focus-visible:ring-2 focus-visible:ring-[var(--phx-brand-primary)] focus-visible:ring-offset-2 ${variants[variant] || variants.primary} ${className}`} {...rest} />;
}
